// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fiU6qk0eyVghH8 {
  position: relative;
  width: 321px;
  margin-bottom: 16px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 3px;
  text-align: center;
}
.fiU6qk0eyVghH8 .Wwzui2QdwgvDGs {
  margin-top: 40px;
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: 18px;
  margin-bottom: 0;
}
.fiU6qk0eyVghH8 .MO2HI2AE5kRnRZ {
  font-weight: var(--ds-font-weight-regular, 400);
  margin-top: 8px;
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
}
.fiU6qk0eyVghH8 .YhnNoRUTyYOPhB {
  margin-bottom: 16px;
}
.fiU6qk0eyVghH8 .YhnNoRUTyYOPhB .E3qD3MV173RMEW {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.fiU6qk0eyVghH8 .YhnNoRUTyYOPhB .bhaw9n6JmzxTgr,
.fiU6qk0eyVghH8 .YhnNoRUTyYOPhB .KeonaFyEHAH2nD {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: 5px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.fiU6qk0eyVghH8 .QuHQhqKgDZH9pL {
  margin-bottom: 16px;
}
.fiU6qk0eyVghH8 .QuHQhqKgDZH9pL .rsQ_BfmFUJ2aqG {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: 5px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.fiU6qk0eyVghH8 .j2Uj1cIvVat0GA {
  display: grid;
  height: 70px;
  padding: 0 15px;
  border: 1px solid var(--ds-border, #091e4224);
  background: var(--ds-background-neutral, #091e420f);
  place-items: center;
}
.fiU6qk0eyVghH8 .j2Uj1cIvVat0GA p {
  margin-bottom: 0;
}
@media only screen and (max-width: 450px) {
  .fiU6qk0eyVghH8 {
    width: 265px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planCard": `fiU6qk0eyVghH8`,
	"name": `Wwzui2QdwgvDGs`,
	"info": `MO2HI2AE5kRnRZ`,
	"priceContainer": `YhnNoRUTyYOPhB`,
	"price": `E3qD3MV173RMEW`,
	"frequency": `bhaw9n6JmzxTgr`,
	"pricingVaries": `KeonaFyEHAH2nD`,
	"ctaContainer": `QuHQhqKgDZH9pL`,
	"currentPlan": `rsQ_BfmFUJ2aqG`,
	"enterpriseFooter": `j2Uj1cIvVat0GA`
};
export default ___CSS_LOADER_EXPORT___;
